import React, { useEffect } from 'react';
import Template from './Template/Template';
import BankCautionIcon from 'src/assets/images/bank_caution-icon.svg';
import './BankFailure.scss';

export const PartialBankFailure = ({ dispatchPageLoad, isSalesForceRep }) => {
  useEffect(() => {
    dispatchPageLoad('PARTIAL_BANK_FAILURE');
  }, [dispatchPageLoad]);
  return (
    <div>
      {!isSalesForceRep && (
        <Template
          image={BankCautionIcon}
          header={`Your bank has been partially associated.`}
          msg={
            <div>
              The bank you have added has been successfully linked to some of
              your eligible funds. The remaining associations may take 2-3
              business days.
              <br></br>
              Visit the bank preferences page to view the status of your bank
              add.
            </div>
          }
          nextButton={`View Bank Preferences`}
        />
      )}
      {isSalesForceRep && (
        <Template
          image={BankCautionIcon}
          header={`Your bank has been partially associated.`}
          msg={
            <div>
              The bank you have added has been successfully linked to some of
              your eligible agreements. The remaining associations may take 2-3
              business days.
              <br></br>
              Visit the bank preferences page to view the status of your bank
              add.
            </div>
          }
        />
      )}
    </div>
  );
};

export default PartialBankFailure;
